<!--Header-->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Proton Accelerator Status</ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>
<!--Tabulator-->
<ion-segment fill="outline" color="medium" [(ngModel)]='display'>
  <ion-segment-button value='info'>
    Info
  </ion-segment-button>
  <ion-segment-button value='status'>
    Status
  </ion-segment-button>
</ion-segment>
<ion-content>

  <div class="height-100"[ngSwitch]="display">
    <!--HIPA Info Image-->
    <div class="height-100" *ngSwitchCase="'info'">
      <pinch-zoom class="height-100" *ngIf="status_url != false">
        <img class="img-status" alt="HIPA Info" [src]="status_url">
      </pinch-zoom>
    </div>
    <!--Hipa Status Image-->
    <div class="height-100" *ngSwitchCase="'status'">
      <pinch-zoom class="height-100" *ngIf="status_url2 != false">
        <img class="img-status" alt="HIPA Status" [src]="status_url2">
      </pinch-zoom>
    </div>
  </div>

  <!--refresh button-->
  <ion-fab vertical="bottom" (click)="doRefresh()" horizontal="end" slot="fixed">
    <ion-fab-button color="dark">
      <ion-icon *ngIf="!refreshIcon" name="refresh"></ion-icon>
      <ion-spinner *ngIf="refreshIcon" name="dots"></ion-spinner>
    </ion-fab-button>
  </ion-fab>
</ion-content>
